import { apiUrl, getList, getSingleRecord, getAll } from './apiUtils';
import type { ApiListParamsWithUnderscores } from '../types/api/listParams';
import type { ListApiResponse } from '../types/apiResponse';
import type { CurrencyItemModel } from '../types/api/currencies';

const baseUrl = apiUrl + '/currencies/';

export function getCurrencies(
  params?: ApiListParamsWithUnderscores
): Promise<ListApiResponse<CurrencyItemModel>> {
  return getList<CurrencyItemModel>(`${baseUrl}search`, params);
}

export function getCurrencyById(id: string): Promise<CurrencyItemModel> {
  return getSingleRecord<CurrencyItemModel>(baseUrl, id);
}

export function getAllCurrencies(): Promise<CurrencyItemModel[]> {
  return getAll(baseUrl);
}
